import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    if (window.fbq) return;
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', '1113755163547223');
    window.fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-162">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=1113755163547223&ev=PageView&noscript=1" alt="facebook-pixel" data-id="element-163" />
    </noscript>;
}
// Export function to track Lead events
export const trackLead = () => {
  if (window.fbq) {
    window.fbq('track', 'Lead');
  }
};
declare global {
  interface Window {
    fbq: any;
  }
}